import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import '../estilo/servicios.css';

export const Servicios = () => {


    return (
        <>
            {/* SECCIÓN SERVICIOS - COPIA EXACTA DEL STITCH */}
            <section className="margen1" id="servicios">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="text-center mb-8">
                        <h1 className="titulo1 text-center mb-[1rem]">Servicios</h1>
                        <p className=" max-w-2xl mx-auto text-lg ">Soluciones digitales de vanguardia diseñadas para escalar tu presencia<br className="hidden sm:block" /> y optimizar tus procesos.</p>
                    </div>





                    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 servicios-items">
                        <div class="service-card has-link p-10 rounded-3xl flex flex-col items-center text-center">
                            <Link to={`${process.env.REACT_APP_URL_FOLDER}/paginasweb`}>
                                <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                    <span class="material-symbols-outlined text-4xl">web</span>
                                </div>
                                <h3 >Landing Pages</h3>
                                <p >Páginas simples y efectivas diseñadas para convertir.</p>
                            </Link>
                        </div>
                        <div class="service-card has-link p-10 rounded-3xl flex flex-col items-center text-center">
                            <Link to={`${process.env.REACT_APP_URL_FOLDER}/paginasweb`}>
                                <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                    <span class="material-symbols-outlined text-4xl">shopping_cart</span>
                                </div>
                                <h3 >Tienda Virtual</h3>
                                <p>Vende online 24/7 con una plataforma robusta y profesional.</p>
                            </Link>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">smartphone</span>
                            </div>
                            <h3 >Apps Móviles</h3>
                            <p >Tu negocio en el celular de tus clientes con apps nativas.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">settings_suggest</span>
                            </div>
                            <h3 >Automatización de Sistemas</h3>
                            <p >Optimiza tu software y procesos para ahorrar tiempo.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center lg:col-start-2">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">campaign</span>
                            </div>
                            <h3 >Campañas en Redes Sociales</h3>
                            <p >TikTok, IG, Google, YouTube, FB potenciados con IA.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">send</span>
                            </div>
                            <h3 >Notificaciones WhatsApp</h3>
                            <p >Campañas masivas a tus clientes con alta tasa de apertura.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">forum</span>
                            </div>
                            <h3 >Chatbots de WhatsApp con IA</h3>
                            <p >Atención y pedidos por voz y texto automatizados.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">videocam</span>
                            </div>
                            <h3 >Filmación de Video</h3>
                            <p >Capturamos tus mejores momentos con equipo de alta gama.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">movie_edit</span>
                            </div>
                            <h3 >Edición de Video</h3>
                            <p >Post-producción profesional para que tu contenido destaque.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">psychology</span>
                            </div>
                            <h3 >Videos con IA Humana</h3>
                            <p >Presentadores virtuales impactantes que elevan tu marca.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">3d_rotation</span>
                            </div>
                            <h3 >Animación e Ilustración 3D y 2D</h3>
                            <p >Gráficos con profundidad y arte digital que dan vida a tus ideas.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">ads_click</span>
                            </div>
                            <h3 >Publicidad en Vía Pública</h3>
                            <p >Cartelería estratégica para captar la atención local.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">restaurant_menu</span>
                            </div>
                            <h3 >Menús Digitales</h3>
                            <p >Precios actualizados para TV y Web en restaurantes.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">school</span>
                            </div>
                            <h3 >Clases de Informática</h3>
                            <p >Capacitación a medida para dominar nuevas tecnologías.</p>
                        </div>
                        <div class="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div class="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span class="material-symbols-outlined text-4xl">security</span>
                            </div>
                            <h3 >Ciberseguridad</h3>
                            <p >Protegemos tus datos y la integridad de tu empresa.</p>
                        </div>

                    </div>






                    <div class="mt-[6rem] max-w-4xl w-full mx-auto text-center space-y-8 lg:px-6 lg:py-12 md:py-20 rounded-3xl lg:border border-gray-900 dark:border-gray-800 bg-white/50 dark:bg-transparent backdrop-blur-sm">
                        <h2 class="text-2xl md:text-6xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                            ¿Listo para transformar <br class="hidden md:block" /> tu <span class="text-primary">negocio?</span>
                        </h2>
                        <p class="max-w-2xl mx-auto text-lg md:text-xl  leading-relaxed ">
                            Impulsa tu negocio con tecnología innovadora y alcanza tus objetivos. Hablemos de tu próximo proyecto.
                            <span class="block mt-4 text-xl md:text-2xl font-bold text-gray-900 dark:text-white md:whitespace-nowrap">¡Construyamos algo juntos!</span>
                        </p>
                        <div class="pt-6">
                            <a class="inline-flex items-center justify-center  px-3  lg:px-10 py-4 bg-primary hover:bg-blue-700 text-white text-lg font-semibold rounded-xl transition-colors duration-300 group" href="https://api.whatsapp.com/send/?phone=5491125870303&text=&text=Hola,+quiero+iniciar+proyecto..." rel="noopener noreferrer" target="_blank">
                                <span>Iniciar Proyecto</span>
                                <span class="material-icons lg:ml-2 transition-transform duration-300 group-hover:translate-x-2">trending_flat</span>
                            </a>
                        </div>
                    </div>










                </div>
            </section >
        </>
    );
};


/**
 


<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <a href="/paginasweb" className="service-card has-link p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">web</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Landing Pages</h3>
                            <p className="text-base font-medium dark:font-normal">Páginas simples y efectivas diseñadas para convertir.</p>
                        </a>
                        <a href="/paginasweb" className="service-card has-link p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">shopping_cart</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Tienda Virtual</h3>
                            <p className="text-base font-medium dark:font-normal">Vende online 24/7 con una plataforma robusta y profesional.</p>
                        </a>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">smartphone</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Apps Móviles</h3>
                            <p className=" text-base font-medium dark:font-normal">Tu negocio en el celular de tus clientes con apps nativas.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">settings_suggest</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Automatización de Sistemas</h3>
                            <p className=" text-base font-medium dark:font-normal">Optimiza tu software y procesos para ahorrar tiempo.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">campaign</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Campañas en Redes Sociales</h3>
                            <p className=" text-base font-medium dark:font-normal">TikTok, Instagram, Google, YouTube, Facebook potenciados con IA.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">send</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Notificaciones WhatsApp</h3>
                            <p className=" text-base font-medium dark:font-normal">Campañas masivas a tus clientes con alta tasa de apertura.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">forum</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Chatbots de WhatsApp con IA</h3>
                            <p className=" text-base font-medium dark:font-normal">Atención y pedidos por voz y texto automatizados.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">videocam</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Filmación de Video</h3>
                            <p className=" text-base font-medium dark:font-normal">Capturamos tus mejores momentos con equipo de alta gama.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">movie_edit</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Edición de Video</h3>
                            <p className=" text-base font-medium dark:font-normal">Post-producción profesional para que tu contenido destaque.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">psychology</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Videos con IA Humana</h3>
                            <p className=" text-base font-medium dark:font-normal">Presentadores virtuales impactantes que elevan tu marca.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">3d_rotation</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Animación e Ilustración 3D y 2D</h3>
                            <p className=" text-base font-medium dark:font-normal">Gráficos con profundidad y arte digital que dan vida a tus ideas.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">ads_click</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Publicidad en Vía Pública</h3>
                            <p className=" text-base font-medium dark:font-normal">Cartelería estratégica para captar la atención local.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">restaurant_menu</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Menús Digitales</h3>
                            <p className=" text-base font-medium dark:font-normal">Precios actualizados para TV y Web en restaurantes.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">school</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Clases de Informática</h3>
                            <p className=" text-base font-medium dark:font-normal">Capacitación a medida para dominar nuevas tecnologías.</p>
                        </div>
                        <div className="service-card p-10 rounded-3xl flex flex-col items-center text-center">
                            <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 text-primary">
                                <span className="material-symbols-outlined text-4xl">security</span>
                            </div>
                            <h3 className="text-xl font-extrabold mb-3">Ciberseguridad</h3>
                            <p className=" text-base font-medium dark:font-normal">Protegemos tus datos y la integridad de tu empresa.</p>
                        </div>
                    </div>

 */